export default __webpack_public_path__ + "icon_offer.08cc819a087998c55ba3b9c596477820.svg";